import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>リーンキャンバス</>,
  alt: 'リーンキャンバス',
  readText: <>新サービスの価値を短時間で言語化するフレームワーク</>,
  imgLarge: '/images/img/download/lean/thumbnail_lean.webp',
  imgCapture: '/images/img/download/lean/capture_lean.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料では顧客視点でビジネスの価値を定義し、実現性を検証する方法について解説しております。新規事業のビジネスモデルを可視化したい方や、今すぐ使えるリーンキャンバス設計のテンプレートを手に入れたい方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '顧客視点でビジネスの価値を定義し、実現性を検証する方法',
  secondHalf2: 'リーンキャンバスを設計する際のポイントや運用時の注意点',
  secondHalf3: '今すぐ使えるリーンキャンバスのテンプレート',
}

const DownloadLean: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'afae4416-bf83-4401-a355-05dc4593052d', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], { opacity: 0, y: 50 });

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    });

    const commonTo = { opacity: 1, y: 0 };

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1);
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents
            leftContentData={leftContentData}
            isSecondContent={true}
          />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadLean
